import { render, staticRenderFns } from "./clients.html?vue&type=template&id=66bb2b0c&scoped=true&"
import script from "./clients.ts?vue&type=script&lang=js&"
export * from "./clients.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bb2b0c",
  null
  
)

export default component.exports